import type { SVGProps } from 'react';

export const MyCropwiseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.9131 12.6515C11.4364 12.1672 12.2875 11.7977 13.4015 11.5401C13.3499 11.7421 13.2991 11.9596 13.249 12.1939L13.2234 12.3147C13.0798 12.9951 12.9708 13.5115 12.7151 13.8558L12.7141 13.8572C12.5321 14.1029 12.3728 14.2355 12.2196 14.3228C12.0593 14.4141 11.8459 14.49 11.5096 14.548C11.0719 14.6228 10.6504 14.6594 10.2657 14.6873C10.2214 14.3055 10.2332 13.9835 10.2948 13.705C10.3966 13.2483 10.5807 12.9588 10.9131 12.6515Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 4H10L12 6H20C21.1 6 22 6.9 22 8V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18L2.01 6C2.01 4.9 2.9 4 4 4ZM13.8957 10.2136L13.828 10.2262C13.6168 10.2659 13.3973 10.3105 13.1784 10.3601C11.9671 10.6354 10.8569 11.0685 10.098 11.7708C9.60693 12.2247 9.28401 12.7232 9.1233 13.4449C9.02745 13.8779 9.01711 14.337 9.07348 14.8242C9.08379 14.9132 9.09633 15.0032 9.11099 15.0942C9.15804 15.3862 9.2269 15.688 9.31378 16C9.59554 15.9369 9.8575 15.9187 10.1357 15.8994L10.1873 15.8958C10.6144 15.8661 11.1471 15.8274 11.7126 15.7307C12.5593 15.5848 13.1471 15.2887 13.6784 14.5714C14.1003 14.0035 14.2604 13.2278 14.3855 12.622C14.3981 12.5611 14.4103 12.502 14.4224 12.4449C14.5216 11.9813 14.6207 11.6022 14.7176 11.2911C14.7952 11.0421 14.8713 10.8367 14.9447 10.6667L14.9688 10.6121C15.0594 10.4066 15.1318 10.2423 15.281 10C15.0588 10.0279 14.5273 10.0977 13.9132 10.2104L13.8957 10.2136Z"
      fill={props.fill ?? 'white'}
    />
  </svg>
);

export default MyCropwiseIcon;
